const config = {
  envName: ENVIRONMENT_NAME,
  version: APP_VERSION,
  buildDate: DATE_BUILT
}

export default config
